






import Vue from 'vue';

export default Vue.extend({
  name: 'Home',
  methods: {
    goToProfile(): void {
      // console.log(this);
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      // window.haha = this;
      this.$root.singleSpa.navigateToUrl('/profile');
    },
  },
});
